export const toOptions = (items, attribute) =>
  items.map(item => ({
    value: attribute ? item[attribute] : item,
    label: attribute ? item[attribute] : item,
  }));
